import { useState, useEffect } from 'react';
import useStore from './store';
import { decorationRepository } from '../../../domain/decorationsRepository';


export const useDecorationTypes = () => {

    const data = useStore((state) => state.decorationTypeList)
    const setData = useStore((state) => state.setDecorationTypeList)

    const [isLoading, setIsLoading] = useState(!data);
    const [error, setError] = useState(null);

    console.log(`DEC_TEST data: ${data}`)

    useEffect(() => { // Axios request use to be inside useEffect to get executed once.
        if (!data) {
            setIsLoading(true)
            setError(null)
            decorationRepository.getDecorationTypes()
                .then((data) => {
                    setData(data)
                    setIsLoading(false)
                })
                .catch((err) => {
                    console.error("Failed to fetch decoration types:", err)
                    setError(err)
                    setIsLoading(false)
                });
        } else {
            setIsLoading(false) // Data can already be in the store (e.g. BodyDecorations remounts via key={typeCode} on typeCode change), so the fetch above never runs.
        }
    }, [data, setData]);

    return { data, isLoading, error };
};